import React from 'react'
import Container from '@material-ui/core/Container';
import mapa from '../../assets/mapa2.png';
import namaste from '../../assets/namaste.svg';


const Section2 = () => {
  return (
    <div id='ubicacion' className='section noPadBot'>
        <Container className='relative flex flexCenter flexCol'>
        <img className='logoHero' src={namaste} alt="Logo Namasté" />
              <p className='textCenter'>Una propuesta única frente al mar y en un marco natural único, con todo el confort de un proyecto pensado para una verdadera inversión sensorial</p>      
          <div className="flex flexCol margtop relative mapa">
            <div className="floatTitle shadow">
              <h2>Ubicación</h2>
              <p>Ambrosetti y la playa<br />
              Mar Chiquita - Buenos Aires
              </p>
            
            </div>
              <img src={mapa} alt="Mapa"/>

          </div>
        </Container>
    </div>
  )
}

export default Section2